<template>
  <section class="content-page">

    <!-- HEADER -->
    <!-- INFLUENCER PROFILE HEADER -->
    <section class="inf-header">

    <div class="inf-cover"></div>

    <div class="inf-profile">

        <div class="inf-avatar">
        {{ influencerName.charAt(0) }}
        </div>

        <div class="inf-info">
        <h2>{{ influencerName }}</h2>
        <p class="inf-subtitle">
            Exclusive content from this creator
        </p>

        <div class="inf-stats">
            <div>
            <strong>{{ post_cnt }}</strong>
            <span>Posts</span>
            </div>

            <div>
            <strong>{{ follow_cnt }}</strong>
            <span>Followers</span>
            </div>
        </div>
        </div>

        <div class="inf-actions">
        <button @click="$router.back()">
            ← Back
        </button>
        </div>

    </div>

    </section>

    <!-- SEARCH & FILTERS -->
    <section class="controls">
      <input
        v-model="filters.search"
        type="text"
        placeholder="Search updates…"
      />

    </section>

    <!-- EMPTY STATE -->
    <div v-if="!posts.length" class="empty">
      <h3>No updates found</h3>
      <p>Try adjusting your search or filters.</p>
    </div>

    <!-- TIMELINE -->
    <section v-else class="timeline">
      <div class="space-y-8">

  <div
    v-for="post in formattedPosts"
    :key="post.fcontent_id"
    class="bg-white rounded-3xl p-6 premium-shadow border border-slate-100"
  >

    <!-- HEADER -->
    <div class="flex justify-between items-center mb-4">
      <div>
        <p class="font-bold text-slate-900">
          {{ post.user_name }}
        </p>
        <p class="text-xs text-slate-400">
          {{ post.fcontent_created_at }}
        </p>
      </div>

      <span
        class="text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full"
        :class="post.fcontent_type === 'poll'
          ? 'bg-purple-50 text-purple-700'
          : post.fcontent_type === 'image'
          ? 'bg-blue-50 text-blue-700'
          : 'bg-amber-50 text-amber-700'"
      >
        {{ post.fcontent_type }}
      </span>
    </div>

    <!-- TEXT -->
    <p v-if="post.fcontent_text" class="mb-4 text-slate-800 font-medium">
      {{ post.fcontent_text }}
    </p>

    <!-- ================= IMAGE ================= -->
    <div v-if="post.fcontent_type === 'image' && post.media?.image">
      <img
        :src="baseUrl + post.media.image"
        class="rounded-2xl w-full object-cover max-h-[400px]"
      />
    </div>

    <!-- ================= LINK ================= -->
    <div
      v-else-if="post.fcontent_type === 'link' && post.media?.link"
      class="border rounded-xl p-4 bg-slate-50 hover:bg-slate-100 transition"
    >
      <a
        :href="post.media.link"
        target="_blank"
        class="text-blue-600 font-semibold break-all"
      >
        {{ post.media.link }}
      </a>
    </div>

    <!-- ================= POLL ================= -->
    <div
  v-else-if="post.fcontent_type === 'poll' && post.media"
  class="space-y-4"
>

  <!-- Question -->
  <p class="font-semibold text-slate-900">
    {{ post.media.question }}
  </p>

  <!-- Options -->
  <div
    v-for="opt in post.poll_results"
    :key="opt.option"
    @click="handleVote(post.fcontent_id, opt.option)"
    class="relative border rounded-xl px-4 py-3 transition overflow-hidden"
    :class="[
      post.has_voted ? 'cursor-default' : 'cursor-pointer hover:bg-slate-50',
      opt.option === post.my_vote ? 'border-green-500 bg-green-50' : ''
    ]"
  >

    <!-- Progress bar (only after vote) -->
    <div
      v-if="post.has_voted===1"
      class="absolute left-0 top-0 h-full bg-green-200 transition-all duration-500"
      :style="{ width: opt.percent + '%' }"
    ></div>

    <!-- Content -->
    <div class="relative flex justify-between items-center font-medium">
      <span>{{ opt.option }}</span>

      <span v-if="post.has_voted">
        {{ opt.percent }}%
      </span>
    </div>

  </div>

  <!-- Total votes -->
  <p v-if="post.has_voted" class="text-xs text-slate-400">
    {{ post.total_votes }} votes
  </p>

</div>

  </div>

</div>
    </section>

    <!-- PAGINATION -->
    <section v-if="totalPages > 1" class="pagination">
      <button :disabled="page_no === 1" @click="page_no--">Prev</button>
      <span>Page {{ page_no }} of {{ totalPages }}</span>
      <button :disabled="page_no === totalPages" @click="page_no++">Next</button>
    </section>
     <FanIntro1
      :open="showDemoModal"
      @submit="saveDemo"
    />
     <!-- <FanIntro2
      :open="showDemoModal1"
      @submit="saveDemo1"
    /> -->
  </section>
</template>

<script>
import { getTimeline } from "../apis/fanconapis";
import { apiBaseUrl } from "../apis/appconst";
import FanIntro1 from "@/comps/FanIntro1.vue";
// import FanIntro2 from "@/comps/FanIntro2.vue";
import { getBasicProfileApi1,votePollApi } from "@/apis/fanapis";
import { useToast } from "vue-toastification";

export default {
  components:{FanIntro1},
  data() {
    return {
      toast:null,
      showDemoModal: false,
      // showDemoModal1: false,
      user_id: null,
      infId:"",
      page_no: 0,
      posts: [],
      total: 0,
      follow_cnt:0,
      post_cnt:0,
      influencerName: "",
      followerCount: 0,
      baseUrl: apiBaseUrl,
      filters: {
        search: "",
        creator: ""
      }
    };
  },

  computed: {
    
     formattedPosts() {

  if (!Array.isArray(this.posts)) return [];

  return this.posts.map(post => {
    let parsedMedia = null;

    try {
      parsedMedia = post.fcontent_media
        ? JSON.parse(post.fcontent_media)
        : null;
    } catch (e) {
      parsedMedia = null;
    }

    return {
      ...post,
      media: parsedMedia
    };
  });
}
    ,
   creators() {
      return [...new Map(
        this.posts.map(p => [
          p.creator,
          {
            label: p.creator_name,
            value: p.creator
          }
        ])
      ).values()];
    },
    
    totalPages() {
      return Math.ceil(this.total / 10);
    }
  },

  watch: {
    page_no() {
      this.loadTimeline();
    },

    filters: {
      deep: true,
      handler() {
        this.page_no = 0;
        this.loadTimeline();
      }
    }
  },

  mounted() {
    this.toast = useToast();
    const ldataRaw = sessionStorage.getItem("ldata");
    const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

    if (ldata) {
      this.user_id = ldata.user_id;
      
    }

    this.infId = this.$route.params.infId;
    this.loadTimeline();
    this.loadInit();
  },

  methods: {
   
    async handleVote(contentId, option) {

        const res = await votePollApi({
          user_id: this.user_id,
          content_id: contentId,
          option: option
        });

        if (res.status) {
          this.toast.success("Voted ✅");
          this.loadTimeline(); // refresh
        } else {
          this.toast.error(res.success);
        }
      },
    async saveDemo(data){
      console.log(data)

      sessionStorage.setItem("isIntro3456","done");
      this.showDemoModal=false
    },
    // async saveDemo1(data){
    //   console.log(data)

    //   sessionStorage.setItem("isIntro34567","done");
    //   this.showDemoModal1=false
    // },
    async loadInit(){
       const res = await getBasicProfileApi1({
          user_id: this.user_id
        });

        if (!res.status) {
           const isIntro3456 = sessionStorage.getItem("isIntro3456") || "";
           if(isIntro3456.length <= 0){
            this.showDemoModal = true;
           }
        }
    },
    async loadTimeline() {
      
      const res = await getTimeline({
        user_id: this.user_id,
        page_no: this.page_no,
        search: this.filters.search,
        creator: this.infId
      });

      if (res.status) {
        this.posts = res.records || [];
        this.total = res.total || 0;
        this.follow_cnt = res.followers || 0;
        this.post_cnt = res.posts || 0;
        if (this.posts.length) {
            this.influencerName = this.posts[0].user_name || "Influencer";
        }

      }
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
    },

    nextPage() {
      if (this.page_no + 1 < this.totalPages) {
        this.page_no++;
      }
    },

    prevPage() {
      if (this.page_no > 0) {
        this.page_no--;
      }
    }
  }
};
</script>

<style scoped>
.content-page {
  max-width: 1440px;
  margin: auto;
  padding: 48px;
}

/* HEADER */
.header {
  margin-bottom: 24px;
}

.subtitle {
  color: #64748b;
  margin-top: 6px;
}

/* CONTROLS */
.controls {
  display: flex;
  gap: 12px;
  margin-bottom: 32px;
}

.controls input,
.controls select {
  flex: 1;
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fafc;
  font-weight: 600;
}

/* EMPTY */
.empty {
  margin-top: 80px;
  text-align: center;
  color: #64748b;
}

/* TIMELINE */
.timeline {
  position: relative;
  margin-left: 20px;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e5e7eb;
}

.event {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
  position: relative;
}

.dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #0f172a;
  margin-top: 24px;
  z-index: 1;
}

.event-card {
  background: white;
  border-radius: 20px;
  padding: 24px;
  border: 1px solid #e5e7eb;
  width: 100%;
}

/* EVENT HEADER */
.event-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #0f172a;
  color: white;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meta h4 {
  font-weight: 800;
}

.meta span {
  font-size: 12px;
  color: #64748b;
}

.badge {
  margin-left: auto;
  background: #f1f5f9;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

/* EVENT BODY */
.event-body p {
  font-size: 15px;
  line-height: 1.6;
}

.event-body img {
  width: 100%;
  border-radius: 14px;
  margin-top: 16px;
}

/* PAGINATION */
.pagination {
  margin-top: 48px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

/* RESPONSIVE */
@media (max-width: 640px) {
  .timeline {
    margin-left: 0;
  }

  .timeline::before {
    display: none;
  }

  .event {
    gap: 12px;
  }

  .dot {
    display: none;
  }
}

/* ===============================
   FAN TIMELINE – MOBILE PATCH
   =============================== */
@media (max-width: 640px) {

  /* Page padding */
  .content-page {
    padding: 20px 16px 72px;
  }

  /* Header */
  .header h2 {
    font-size: 24px;
    line-height: 1.2;
  }

  .subtitle {
    font-size: 14px;
  }

  /* Controls → stacked */
  .controls {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }

  .controls input,
  .controls select {
    padding: 12px;
    font-size: 14px;
    border-radius: 12px;
  }

  /* Empty state */
  .empty {
    margin-top: 48px;
  }

  .empty h3 {
    font-size: 18px;
  }

  .empty p {
    font-size: 14px;
  }

  /* Timeline reset (already hides line & dot) */
  .timeline {
    margin-left: 0;
  }

  .event {
    margin-bottom: 24px;
  }

  /* Event card */
  .event-card {
    padding: 16px;
    border-radius: 16px;
  }

  /* Header inside card */
  .event-header {
    gap: 10px;
    margin-bottom: 12px;
  }

  .avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .meta h4 {
    font-size: 14px;
  }

  .meta span {
    font-size: 11px;
  }

  .badge {
    font-size: 10px;
    padding: 4px 8px;
  }

  /* Body text */
  .event-body p {
    font-size: 14px;
    line-height: 1.55;
  }

  .event-body img {
    margin-top: 12px;
    border-radius: 12px;
  }

  /* Pagination */
  .pagination {
    margin-top: 32px;
    justify-content: space-between;
  }

  .pagination span {
    font-size: 13px;
    font-weight: 700;
  }

  .pagination button {
    padding: 10px 14px;
    font-size: 13px;
  }
}
.post-image {
  height: 10rem;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  border-radius: 12px;
}
/* ===============================
   Influencer Header
================================ */

.inf-header {
  margin-bottom: 40px;
}

.inf-cover {
  height: 160px;
  background: linear-gradient(135deg, #0f172a, #1e293b);
  border-radius: 24px;
}

.inf-profile {
  display: flex;
  align-items: center;
  gap: 24px;
  background: white;
  padding: 24px;
  border-radius: 24px;
  margin-top: -60px;
  position: relative;
  box-shadow: 0 8px 40px -12px rgba(0, 0, 0, 0.08);
}

.inf-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: #0f172a;
  color: white;
  font-size: 28px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid white;
}

.inf-info h2 {
  font-size: 24px;
  font-weight: 800;
}

.inf-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.inf-stats {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}

.inf-stats strong {
  display: block;
  font-size: 18px;
}

.inf-stats span {
  font-size: 12px;
  color: #64748b;
}

.inf-actions {
  margin-left: auto;
}

.inf-actions button {
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 800;
  background: #f1f5f9;
}
</style>
